// extracted by mini-css-extract-plugin
module.exports = {"sideTrayHeader":"_2JRa8WWM","sideTrayFooter":"_3uxopL2t","pillEdit":"_2vvJy8XU","primarySearch":"z5SawK4J"};